import React from 'react';
import './AboutUsPage.css';

const AboutUsPage = () => {
  const values = [
    { title: 'Innovation', desc: 'Pushing the boundaries of what AI can achieve every day.' },
    { title: 'Integrity', desc: 'Building ethical AI systems with transparency and trust.' },
    { title: 'Excellence', desc: 'Delivering world-class performance in every deployment.' }
  ];

  return (
    <div className="about-container">
      <section className="about-hero">
        <div className="hero-content">
          <h1>We are <span className="highlight">cabptoid</span></h1>
          <p className="subtitle">Architecting the future through advanced neural systems and data intelligence.</p>
        </div>
      </section>

      <section className="mission-vision">
        <div className="mission-card">
          <h2>Our Mission</h2>
          <p>To bridge the gap between human ingenuity and artificial intelligence, creating a symbiotic ecosystem where technology empowers every business to reach its zenith.</p>
        </div>
      </section>

      <section className="values-section">
        <div className="section-header">
          <h2>Our Core Values</h2>
        </div>
        <div className="values-grid">
          {values.map((v, i) => (
            <div key={i} className="value-card">
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="about-cta">
        <div className="cta-content">
          <h2>Join Our Journey</h2>
          <p>We're always looking for brilliant minds to help build the next generation of AI.</p>
          <button className="primary-btn">View Careers</button>
        </div>
      </section>
    </div>
  );
};

export default AboutUsPage;
